module.exports = __webpack_public_path__ + "img/youtube-icon.b0ca0d91.svg";